module.exports = __webpack_public_path__ + "static/media/combat(9).af137b67.PNG";